import React, { useEffect, useState } from 'react';
import { TitleSection, TopContentWrapper, Wrapper } from '../shared.styles';
import { getMarketWppkReportForConsultant } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import DailyTable from './components/DailyTable';
import moment from 'moment';
import styled from 'styled-components';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import Icon from '@/common/components/Icon';
import SelectInput from '@/common/components/SelectInput';

const WrapperCustom = styled.div`
	margin-top: 10px;
	display: flex;
	justify-content: center;
	width: 100%;
	height: 450px;
	overflow: scroll;
`;

const CallingStatsWPPK = () => {
	const [data, setData] = useState();
	const [selectedSuperProduct, setSelectedSuperProduct] = useState(null);

	const {
		commonData: { queues, users, markets, products },
		options: { superProductsOptions },
	} = useCommonDataContext();
	const { makeRequest } = useRequestsContext();

	const handleLoadData = async (superProduct = selectedSuperProduct) => {
		setData(null);

		const superProductProductIds = superProduct
			? (products || [])
					.filter((product) => product.super_product === superProduct.value)
					.map((product) => product._id)
			: [];

		if (superProduct && !superProductProductIds.length) {
			return setData({});
		}

		const allConsultants = queues.reduce(
			(prev, next) => [...prev, ...next.consultants],
			[],
		);

		const payload = {};
		payload.ids = allConsultants;
		payload.from = moment().startOf('day');
		payload.to = moment().endOf('day');
		payload.weights = false;
		payload.type = ['inbound', 'outbound'];
		payload.products = superProductProductIds;

		const { data } = await makeRequest(
			getMarketWppkReportForConsultant.bind(null, payload),
		);

		if (!data) {
			return setData({});
		}

		const result = {};

		Object.entries(data).forEach(([key, value]) => {
			value._id = key;

			result[value.market] = result[value.market]
				? [...result[value.market], value]
				: [value];
		});

		setData(result);
	};

	const handleSuperProductChange = (superProduct) => {
		setSelectedSuperProduct(superProduct);
		handleLoadData(superProduct);
	};

	useEffect(() => {
		if (queues?.length > 0 && !data) {
			handleLoadData();
		}
	}, [queues]);

	return (
		<Wrapper width={600}>
			<TitleSection>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<Icon name='usps' />
					<div style={{ minWidth: '100px' }}>Daily </div>
				</div>
				<TopContentWrapper>
					<SelectInput
						name='Super product'
						options={superProductsOptions}
						selected={selectedSuperProduct}
						setSelected={handleSuperProductChange}
						selectWidth={200}
						showLabel={false}
						placeholder='Super product'
						margin='0'
						isClearable
						menuPortalTarget={document.body}
					/>
					<Icon
						name='arrows-rotate'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>
				</TopContentWrapper>
			</TitleSection>
			<WrapperCustom>
				{data ? (
					<DailyTable data={data} consultants={users} markets={markets} />
				) : (
					<CustomSkeleton width={520} count={18} height={4} />
				)}
			</WrapperCustom>
		</Wrapper>
	);
};

export default CallingStatsWPPK;
